"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

var _arrowInline = _interopRequireDefault(require("./arrow.inline.svg"));

var _excluded = ["className"];

var ArrowIcon = function ArrowIcon(_ref) {
  var className = _ref.className,
      iconProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_arrowInline.default, (0, _extends2.default)({
    className: (0, _classnames.default)(_indexModule.default.Icon, className)
  }, iconProps));
};

ArrowIcon.propTypes = {
  className: _propTypes.default.string
};
var _default = ArrowIcon;
exports.default = _default;